import { render, staticRenderFns } from "./area_crops_m.vue?vue&type=template&id=070e82fd&"
import script from "./area_crops_m.vue?vue&type=script&lang=js&"
export * from "./area_crops_m.vue?vue&type=script&lang=js&"
import style0 from "./area_crops_m.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports